import {$fetch, $post, $put} from '@/services/axios';

export function fetch(params) {
  return $fetch(`customer/recurrings`, params);
}

export const CUSTOMER_BUDGET_CSV_URL = `customer/recurrings/csv`;

export function validate(model) {
  return $post(`customer/recurring/validate`, model);
}

export function add(model) {
  return $put(`customer/recurring`, model);
}

export function update(model) {
  return $post(`customer/recurring/${model.id}`, model);
}
